import React from 'react';
import { LoginFormStyled } from './styled';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Buttons, Inputs } from 'components';

const LoginForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <LoginFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="logo_wrap">
          <img
            className="logo"
            alt="Yamaha logo"
            src="/assets/images/logos/logo.png"
          />
        </div>
        <div className="title_form">Sign in your account</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label="Username"
                // placeholder={t('test')}
                errors={errors.username?.message}
              />
            )}
            name="username"
            defaultValue=""
          />
        </div>
        <div className="input_wrap mb_2">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label="Password"
                // placeholder={t('test')}
                type='password'
                errors={errors.password?.message}
              />
            )}
            name="password"
            defaultValue=""
          />
        </div>
        <Buttons.BgStandard type="submit" label="Sign Me In" />
      </form>
    </LoginFormStyled>
  );
};

LoginForm.propTypes = {};

export default LoginForm;
